// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HvHo","rootNoMargin":"styles_rootNoMargin__33A3f"};